import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { addressFormSchema } from '../addess/schema';

export const deleteAgendaSlotRecurrenceModes = [
  'delete-occurrence',
  'stop-recurrence',
] as const;
const deleteAgendaSlotRecurrenceModeSchema = z.enum(
  deleteAgendaSlotRecurrenceModes,
);
export type DeleteAgendaSlotRecurrenceMode = z.infer<
  typeof deleteAgendaSlotRecurrenceModeSchema
>;

export const addOfficeFormSchema = z
  .object({
    mode: deleteAgendaSlotRecurrenceModeSchema,
  })
  .merge(addressFormSchema);

export type DeleteAgendaSlotRecurrenceFormValues = z.infer<
  typeof addOfficeFormSchema
>;

export const deleteAgendaSlotRecurrenceFormResolver =
  zodResolver(addOfficeFormSchema);
